import React from 'react';
import { Radio } from '../../common/components/formControls';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Col } from 'react-bootstrap';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';

const MarkAsNotApprovedForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues, t }) => {
	const notesOptions = ui.paymentNotesOptions(t);
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Col smOffset={1}><Field name='notes'
				component={Radio}
				label={t('LessonAttendance_AdditionalInfo')}
				entries={notesOptions}
				required
				validate={[validators.required]} />
			</Col>
		</Form>
	);
};

export default reduxForm({ form: 'markAsNotApproved' })(withTranslation()(MarkAsNotApprovedForm));